import Toggle, {Size as ToggleSize} from '@jetbrains/ring-ui/components/toggle/toggle'
import type {ReactNode, ChangeEvent} from 'react'
import React, {memo, useContext, useId} from 'react'

import {DisabledContext} from '../../../../../../../../contexts/DisabledContext'

import styles from './TogglableProperty.css'

type Props = {
  className?: string
  label: string | undefined
  children: ReactNode
  details?: ReactNode
  checked?: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

function TogglableProperty({label, children, details, checked, onChange}: Props) {
  const isDisabled = useContext(DisabledContext)
  const id = useId()

  return (
    <React.Fragment>
      <Toggle
        className={styles.toggle}
        size={ToggleSize.Size16}
        checked={checked}
        onChange={onChange}
        disabled={isDisabled}
      >
        <span id={id}>{label ?? 'Empty label'}</span>
        {details}
      </Toggle>
      {checked && children}
    </React.Fragment>
  )
}

export default memo<Props>(TogglableProperty)
